const Footer = () => {
  const socialMediaLinks = [
    { name: "Facebook", url: "https://www.facebook.com/profile.php?id=100006641689318" },
    { name: "twitter", url: "https://x.com/Sudhirsharma450" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/sudhir-sharma-b8a402207/" },
    { name: "GitHub", url: "https://github.com/Sudhir4500" },
    { name: "Gmail", url:"mailto:sudhirsharma4500@gmail.com" },
  ];

  return (
    <footer className="w-full flex flex-col items-center py-10 mt-10 border-t border-stone-200/50 dark:border-stone-800/50">
      <h3 className="text-stone-500 dark:text-stone-400 mb-6 font-light">Let’s stay connected</h3>
      <div className="flex space-x-6">
        {socialMediaLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center justify-center h-10 w-10 hover:-translate-y-1 transition-transform"
            style={{
              backgroundImage: `url('https://img.icons8.com/color/48/${link.name.toLowerCase().replace(/\s+/g, "-")}.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <span className="sr-only">{link.name}</span>
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
  